"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const course = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        createCourseRegistration: async (mindItemId) => {
            const endpoint = `${url}/v4/mindItems/${mindItemId}/courseRegistration`;
            await httpClient.put(endpoint);
            return;
        },
        getCourseRegistration: async (mindItemId) => {
            const endpoint = `${url}/v4/mindItems/${mindItemId}/courseRegistration`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        buildCourseLaunchLink: async (mindItemId) => {
            const endpoint = `${url}/v4/mindItems/${mindItemId}/courseLaunchLink`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getCertifiedCourseRegistrations: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/certifiedCourseRegistrations`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getUpdatedCourseRegistration: async (userId, payload) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/courseRegistration`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        getUserCourses: async (userId, query) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/courses`;
            const result = await httpClient.get(endpoint, { query });
            return result;
        },
    };
};
exports.default = course;
